<template>
  <div class="column_start_end store_banner">
    <div class="row_center_between gradient_view">
      <text>{{ store }}</text>
      <div class="row_center_around vip_text" v-if="isLogin && showVipCard" @click="toMemberPage">
        <img src="@/assets/triangle.png" />
        <text>VIP會員卡</text>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    store: {
      type: String,
      default: "",
      required: true,
    },
    showVipCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    getCurrentStore() {
      return this.$store.state.basic.currentStore;
    },
    isLogin() {
      return this.$store.getters['userData/isLogin'];
    }
  },
  methods: {
    toMemberPage() {
      this.$router.push(`/${this.getCurrentStore}`)
    }
  },
};
</script>
<style lang="scss" scoped>
.store_banner {
  width: 100%;
  height: 214px;
  background-image: url("@/assets/store/store_banner_background.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  flex-shrink: 0;
}

.gradient_view {
  width: 100%;
  height: 50px;
  padding: 0 4%;
  font-size: 16px;
  font-weight: 400;
  font-family: PingFang SC;
  color: #fff;
  background: rgb(0, 0, 0);
  background: -moz-linear-gradient(270deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.1) 100%);
  background: -webkit-linear-gradient(270deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.1) 100%);
  background: linear-gradient(270deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000", endColorstr="#000000", GradientType=1);
}

.vip_text {
  padding: 8px 10px;
  width: 100px;
  height: 36px;
  border-radius: 6px;
  border: 1px solid #FBCB02;
  color: #FBCB02;
  line-height: 20px;
  font-size: 14px;


  img {
    width: 6px;
    height: 8px;
  }
}
</style>
